import { render, staticRenderFns } from "./StudioNavigation.vue?vue&type=template&id=512b218a&scoped=true&"
import script from "./StudioNavigation.vue?vue&type=script&lang=js&"
export * from "./StudioNavigation.vue?vue&type=script&lang=js&"
import style0 from "./StudioNavigation.vue?vue&type=style&index=0&id=512b218a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b218a",
  null
  
)

export default component.exports